import React, { useEffect, useState } from "react"
import { Seo } from '~/components/shared/seo'

const NotFoundPage = () => {
  const [content404, setContent404] = useState('')

  const get404page = async () => {
    // const req = await fetch('/404-content.txt')
    const req = await fetch('https://cdn.shopify.com/s/files/1/0123/5065/2473/files/404-content.txt?v=1742676287')
    const data = await req.text()
    setContent404(data)
  }

  const checkRedir = async () => {
    if (!window.Use404Hook) {
      setTimeout(()=>{checkRedir()}, 250)
      return
    }
    const path = window.location.pathname
    const params = window.location.search
    const result = await window.Use404Hook.check404(path)

    if (result.url) {
      window.location.href = `${result.url}${params}`
      return
    }
    get404page()
  }

  useEffect(() => {
    checkRedir()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div fof-wr={''} dangerouslySetInnerHTML={{ __html: content404 }} />
  )
}

export default NotFoundPage

// <div fof-wr={''} dangerouslySetInnerHTML={{ __html: content404 }} />

// <>
//   {show404 ? (
//     <div className={styles.e404}>
//       <div className={styles.message}>
//         <div className={styles.cont}>
//           <h1 className={styles.title}>
//             We weren't able to find that page
//           </h1>
//           <span>(404 error)</span>
//           <p>
//             Sorry, the page that you are looking for doesn't exist, or the product is no longer available. While 
//             you are here though, check out one of the collections below to see what we do have in stock.
//           </p>
//         </div>
//       </div>
//       {(pageData && pageData.length > 0) && (
//         <div className={styles.grid}>
//           {pageData.map(item => 
//             <Link key={item.handle} href={`/collections/${item.handle}`} className={styles.item}>
//               <div className={styles.gimage}>
//                 <img 
//                   className={styles.img}
//                   src={imgSize(item.image,700)} 
//                   alt={`Shop ${item.title}`}
//                 />
//               </div>
//               <div className={styles.copy}>
//                 <div className={styles.title}>
//                   {item.title}
//                 </div>
//                 <div className={styles.cta}>
//                   <div className={[cta_link, styles.cta_text].join(' ')}>{item.cta}</div>
//                 </div>
//               </div>
//             </Link>
//           )}
//         </div>
//       )}
//     </div>
//   ) : (
//     <></>
//   )}
// </>

// src="/not-found.js" 
export const Head = () => (
  <>
    <Seo 
      title={'404 - Page not found'}
      description={'404'}
      image={null}
      url={`/404`}
    />
    <script 
      key="notfound" 
      type="text/javascript" 
      src="https://cdn.shopify.com/s/files/1/0123/5065/2473/files/not-found.js?v=1742678773" 
    />
  </>
)

